  <div class="modal-header">
    <h3 class="modal-title font-bold text-center" id="modal-title">Multiple Validations</h3>
  </div>
  <div class="modal-body" id="modal-body">
    <div class="row">
      <div class="col-md-6 col-xs-12">
        <div class="table-responsive">
          <table class="table table-condensed">
            <tr class="active">
              <th width="5%">#</th>
              <th width="30%">Expected value</th>
              <th>Error</th>
            </tr>
            <tbody>
              <tr *ngFor="let item of multipleResults?.expectedObj">
                <td>{{item.sequence}}</td>
                <td>{{item.extractedValue}}</td>
                <td>{{item.errorMessage}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-md-6 col-xs-12">
        <div class="table-responsive">
          <table class="table table-condensed">
            <tr class="active">
              <th width="5%">#</th>
              <th width="30%">Actual value</th>
              <th>Error</th>
            </tr>
            <tbody>
              <tr *ngFor="let item of multipleResults?.actualObj">
                <td>{{item.sequence}}</td>
                <td>{{item.extractedValue}}</td>
                <td>{{item.errorMessage}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
